/* eslint-disable max-len */
import React, { useEffect, useMemo, useState } from 'react';
import useSwitchAccount from 'hooks/useSwitchAccount';
import i18n from 'i18n/config';
import { DateTime } from 'luxon';
import routes from 'routes.path';
import AuthorizationService from 'services/Authorization/authorization.service';
import { Userpilot } from 'userpilot';
import t from 'utils/translationHelper';

import { AccountDto } from '@alpha/auth-dtos';
import { ActionButton } from '@alpha/ui-lib/ui/button';
import { faExternalLink, faHome } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import alphaLogoEn from '../../assets/Alpha_Corpay_Verticle.png';
import backgroundImage from '../../assets/alpha_mountain.jpg';
import alphaLogoFr from '../../assets/Corpay x Alpha LockUp_French - Corporate - Vertical - White.svg';
import alphaLogoDe from '../../assets/Corpay x Alpha LockUp_German - Corporate - Vertical - White.svg';
import alphaLogoIt from '../../assets/Corpay x Alpha LockUp_Italian - Corporate - Vertical - White.svg';
import alphaLogoEs from '../../assets/Corpay x Alpha LockUp_Spanish - Corporate - Vertical - White.svg';
import history from '../../services/history/browserHistory';

const AccountMigrated: React.FC = () => {
  const { currentAccount } = useSwitchAccount();
  const getUserAccounts = async (): Promise<AccountDto[]> => AuthorizationService.getUserAccounts();
  const [migrationStartDate, setMigrationStartDate] = useState<string>();

  useEffect(() => {
    (async () => {
      const userAccounts = await getUserAccounts();
      const liveAccount = userAccounts.find((acc) => acc.id === currentAccount.id);
      const rawDate = liveAccount?.corpayMigrationStartDate;
      const isValidDate = rawDate && DateTime.fromISO(rawDate).isValid;
      setMigrationStartDate(isValidDate ? rawDate : '2030-03-01T11:40:00.000+0000');
    })();
  }, []);

  Userpilot.destroy();

  useEffect(() => {
    if (migrationStartDate && DateTime.fromISO(migrationStartDate) > DateTime.now()) history.push(routes.dashboard);
  }, [migrationStartDate]);

  const alphaCorpayLogoToUse = useMemo(() => {
    switch (i18n.language) {
      case 'en':
        return alphaLogoEn;
      case 'fr':
        return alphaLogoFr;
      case 'es':
        return alphaLogoEs;
      case 'it':
        return alphaLogoIt;
      case 'de':
        return alphaLogoDe;
      default:
        return alphaLogoEn;
    }
  }, [i18n.language]);

  return (
    <div
      style={{
        position: 'relative',
        backgroundColor: 'black',
        width: '100%',
        height: '100vh',
        overflow: 'hidden',
      }}
    >
      <div
        style={{
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundImage: `url(${backgroundImage})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat',
          opacity: 0.6,
        }}
      />
      <div style={{
        position: 'relative',
        zIndex: 1,
        display: 'flex',
        justifyContent: 'right',
        paddingRight: '40px',
        paddingTop: '40px',
      }}
      >
        <img style={{ height: '240px' }} src={alphaCorpayLogoToUse} alt="Alpha Logo" />
      </div>
      <div style={{
        position: 'absolute',
        top: '50%',
        marginLeft: '80px',
        zIndex: 1,
        color: 'white',
        width: '522px',
        transform: 'translateY(-50%)',
      }}
      >
        <div
          style={{
            fontSize: '40px',
            fontWeight: 400,
          }}
        >
          {t('account_migration_in_progress')}
        </div>
        <div
          style={{
            fontSize: '16px',
            fontWeight: 400,
          }}
        >
          {t('account_migrating_description')}
        </div>
        <div
          style={{
            display: 'flex',
            flexDirection: 'row',
            gap: '12px',
          }}
        >
          <ActionButton
            style={{
              backgroundColor: '#F7F7F7',
              color: 'black',
              height: '44px',
              marginTop: '16px',
              minWidth: '146px',
            }}
            onClick={() => {
              history.push(routes.dashboard);
            }}
          >
            <FontAwesomeIcon icon={faHome} style={{ marginRight: '8px' }} />
            {t('go_to_dashboard')}
          </ActionButton>
          {/* <ActionButton
            style={{
              backgroundColor: '#BE1F4B',
              height: '44px',
              marginTop: '16px',
              flex: 1,
            }}
            onClick={() => {
              window.open('https://www.cambridgelink.com/login', '_blank');
            }}
          >
            {t('corpay_cross_border_web')}
            <FontAwesomeIcon icon={faExternalLink} style={{ marginLeft: '8px' }} />
          </ActionButton> */}
        </div>
      </div>
    </div>
  );
};

export default AccountMigrated;
